'use strict';

var _ = require('lodash');
var ChartDashboardRankingsLegendController = function ChartDashboardRankingsLegendController($scope, $rootScope, userPreferencesService) {
  $scope.rankingsList = [{
    label: 'Market',
    value: 'MARKET'
  }, {
    label: 'POS',
    value: 'POS'
  }];
  $scope.getChartTitle = function (rankingValue) {
    var rankingSelected = _.find($scope.rankingsList, {
      value: rankingValue
    });
    if (rankingSelected) {
      return rankingSelected.label;
    }
    return false;
  };
  $scope.setDefaultRanking = function () {
    $scope.rankingName.name = userPreferencesService.getUserSettingComponent('defaultRanking') || 'MARKET';
  };
  $scope.resetSelection = function () {
    $rootScope.$broadcast('dashboard:ranking:reset-selection');
  };
  $scope.isLastYearMode = function () {
    return $scope.screenState.aggregationMode === 'LY';
  };
  $scope.isBudgetMode = function () {
    return $scope.screenState.aggregationMode === 'BUDGET';
  };
  $scope.isTargetMode = function () {
    return $scope.screenState.aggregationMode === 'TARGET';
  };
  $scope.isPercentageMode = function () {
    return $scope.screenState.dataRepresentation === 'percentage';
  };
  $scope.isLoadFactorMetric = function () {
    return $scope.screenState.selectedMetric.id === 'loadFactor';
  };
};
ChartDashboardRankingsLegendController.$inject = ['$scope', '$rootScope', 'UserPreferencesService'];
module.exports = ChartDashboardRankingsLegendController;